import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { EGameStates } from '@Managers/StateManager/GameStates';

export interface EventSubscription {
    event: string | symbol;
    fn: (...args: any[]) => void;
    context?: any;
}

export class WinPresentationEventSubscriptionsBuilder {
    private states: EGameStates[] = [];
    private readonly rules: EventSubscription[] = [];

    during(...states: EGameStates[]) {
        this.states = states;
        return this;
    }

    on(event: string | symbol, fn: (...args: any[]) => void, context?: any) {
        this.rules.push({ event, fn, context });
        return this;
    }

    build(): EventSubscription[] {
        return this.rules.map((rule) => ({
            event: rule.event,
            fn: () => {
                const currentState = gameInstance.gameStore.get(EGameStoreKeys.CurrentGameState);
                const currentSubstate = gameInstance.gameStore.get(EGameStoreKeys.CurrentGameSubState);
                if (!this.states.includes(currentState) && !(currentSubstate && this.states.includes(currentSubstate))) return;
                rule.fn.call(rule.context);
            }
        }));
    }
}
